"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSessionStore = void 0;
const pinia_1 = require("pinia");
exports.useSessionStore = (0, pinia_1.defineStore)("session", {
    state() {
        return {
            id: "00000000-0000-0000-0000-000000000000"
        };
    }
});
